///<reference path="../../../commons/AppBaseComponent.ts"/>
import {Component, Input, OnChanges, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {forkJoin, Observable, of as observableOf, of} from 'rxjs';
import {debounceTime, map, tap} from 'rxjs/operators';
import {Location} from '@angular/common';
import {
  BillingSetup,
  Dataset,
  DatasetType,
  Folder,
  FourdCesiumHelper,
  FourDService,
  Job,
  JobBatch,
  Transform,
  TransformGroup,
  TransformType
} from '4d-mapper';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatSnackBar} from '@angular/material';
import {APIDialog} from '../../../commons/dialogs/explorer.dialogs';
import {VasatSearchQuery} from 'vasat';
import {MainService} from '../../main.service';
import {TranslateService} from '@ngx-translate/core';
import {AppService} from '../../../commons/app.service';
import {MetadataDialogComponent} from './metadata-dialog/metadata-dialog.component';
import {MapService} from '../../../commons/map.service';
import {ReferenceAnnotation} from './reference-annotation';
import {HttpClient} from '@angular/common/http';
import {MapClickHandler, MapComponent} from '../map.component';
import {TermsConditionDialogComponent} from './terms-condition-dialog/terms-condition-dialog.component';
import {PaymentComponent} from './payment/payment.component';
import {Constants} from '../../../commons/Constants';
import {InspectionComponent} from '../list-views/inspect.component';
import {BaseComponent} from '../../../commons/BaseComponent';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EpsgHelperService } from '../../../service/epsg-helper.service';
import { ReferenceAnnotationMarkedImages } from './reference-annotation-markedImages';

// import { }

const Cesium = (<any>window).Cesium

const BTDropIn = require('braintree-web-drop-in');

@Component({
  selector: 'app-photogram',
  templateUrl: './photogram.component.html',
  styleUrls: ['./photogram.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PhotogramComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges, MapClickHandler {

  debug:boolean = Constants.debug_off;

  debugJob:number = 0;

  // refactor

  // area we're doing the job over (rectangle)
  jobArea:any = null;

  // the Cesium entity for the area
  jobAreaEntity:any = null;


  currentScene: TransformGroup
  everything:any = null;

  // are we loading our project, scene, job?
  loading:boolean = false;

  // does the scene have any images? We need some ...
  hasImages:boolean = true;



  // temporary fix for not seeing subtransforms
  subTransforms:any = null;

  // old code

  currentJob: any;

  jobs: VasatSearchQuery<Job>
  private refreshStatusInterval: any;
  jobRunning = false;
  // jobStatus:string = 'OK';
  currentJobName = '';
  // @ViewChild('jobName') jobNameInput: ElementRef;
  private cameraPositionsFromFolder = [];
  private cameraPositionsFromFolderID = [];
  private transformsFromFolder: Transform[] = [];
  importMetaDataError: boolean = false;
  canStartFullProcess: boolean = false;
  private viewer: any;
  private screenSpaceEventHandler: any;
  private camera: any;
  helper: FourdCesiumHelper;
  handler: any
  private scene: any;
  @Input()
  public myCallback: Function;
  rectangleSelector = new Cesium.Rectangle();
  private getSelectorLocations: any;
  public selector: any;
  public selectionEnabled: boolean = false;
  private mouseDown: boolean = false;
  private firstPointSet: boolean = false;
  private toPlacOnCesium: Dataset[] = [];
  batches: VasatSearchQuery<JobBatch>;
  initalTransform: JobBatch;
  private selectedAread: boolean = false;
  cartesian = new Cesium.Cartesian3();
  tempCartographic = new Cesium.Cartographic();
  firstPoint = new Cesium.Cartographic();
  private length: any;
  private height: any;
  private centerX: number;
  private centerY: number;
  private plottedTransform: Transform;
  private fileUploaded: boolean = false;
  private csvRecords: any[] = [];

  TYPE_DZI;
  TYPE_THUMB;
  folderAdded: boolean = true;

  // refactor: converting this one into a Map instead of an array
  public referenceAnnotation: Map <string,ReferenceAnnotation> = new Map();

  annotationDataSource = new Cesium.CustomDataSource('reference-annot');
  clickedButton = -1;
  // private pinFromReferenceAnnotation = [];
  private plottedTransformFull = [];
  private batchUpdate = false;

  private btInstance: any;
  jobAmount = 5000.00
  private billingSetup: any;
  proceesingPay: any = false;
  private XML_BLOCKS: TransformType | undefined;
  isFullProcessing: boolean;
  currentWorkingReferenceAnnotation: ReferenceAnnotation;
  progressPercent: number = 0;
  timeLeft: any;
  pdfRefport: Dataset;
  private gigaPixels: number = 0;
  progressStage: number = 1;
  disablePreviewRun: boolean;
  private metaDataImported: boolean;
  private metaDataUploaded: boolean;
  private referenceUploaded: boolean;
  edgeBrowserError: boolean;
  private xmlDatasetType: DatasetType | undefined;
  private pdfDatasetType: DatasetType | undefined;
  private textDatasetType: DatasetType | undefined;


  // refactor: UI sections
  showOptionalCoords:boolean = false;
  showOptionalControlPoints:boolean = false;
  showOptionalSelection:boolean = false;

  showCoverageArea:boolean = true;

  constructor(private fourD: FourDService, public service: AppService, private r: Router, sn: MatSnackBar, d: MatDialog, private t: TranslateService, 
    private mainService: MainService, private trans: TranslateService,
              public mapService: MapService, private httpClient: HttpClient, private mapComp: MapComponent, private ar: ActivatedRoute,
              public epsgHelper: EpsgHelperService,
              private _formBuilder: FormBuilder, public location: Location
              ) {
    super(r, sn, d);
    this.TYPE_DZI = this.fourD.transformTypes.find(t => t.uid == 'photo-dzi')
    this.TYPE_THUMB = this.fourD.transformTypes.find(t => t.uid == 'thumb')
    this.XML_BLOCKS = this.fourD.transformTypes.find(t => t.uid == 'xml-blocks')
    if (this.mapService.sceneTransforms.findIndex(t => t['ds_name'] === 'Quickview_LowResolution.tif') !== -1) {
      this.disablePreviewRun = true;
    }
    this.xmlDatasetType = this.fourD.datasetTypes.find(dt => dt.uid === 'xml-blocks');
    this.pdfDatasetType = this.fourD.datasetTypes.find(dt => dt.uid === 'pdf');
    this.textDatasetType = this.fourD.datasetTypes.find(dt => dt.uid === 'text');

    // when the project is ready
    this.mapService.onReady().subscribe(p => {
      if ( this.debug ) { console.log ( 'photogram :: construct() mapService.onReady() RESULT', p); }
      this.onProjectReady();
    });

    if ( this.debug ) { console.log ( 'photogram :: construct()'); }
  }

  // the process (as far as I can tell)
  //  1. construct()
  //  2. onReady()
  //  3. processReady()
  //  4. initPhotogram()
  //  5.     setupViewer...()
  //  6.     refresh() x 4 (!!!! aaaargh!!!)

  onProjectReady() {
      if ( this.debug ) { console.log ( 'photogram :: onReady()'); }
    // because of local coordinates the sequence of loading scene is changed so once scene is ready we process
    if (this.mapService.scene) {
      if ( this.debug ) { console.log ( 'photogram :: onReady() mapService.scene = true'); }
      this.onSceneReady();
    } else {
      if ( this.debug ) { console.log ( 'photogram :: onReady() mapService.scene = false');}
      this.addSubscription('test',
        this.mapService.onSceneChange('photogram.component').subscribe(_ => {
          if ( this.debug ) { console.log ( 'photogram :: onReady() mapService.scene = false RESULT'); }
          this.onSceneReady();
        })
      );
    }
  }

  onSceneReady() {
    if ( this.debug ) { console.log ( 'photogram :: onSceneReady()', this.mapService.scene);}

    this.mapComp.openPhotoBucket();
    this.mapComp.setTab('layers')
    this.mapComp.detailsNav.open()
    this.mapComp.activeDetails = this;
    this.loading = true;

    if ( this.mapService.scene._photo_count < 1 ) {
      this.loading = false;
      this.hasImages = false;
    } else {
      this.initPhotogram();
    }
    
  }

  destroy() {

    if ( this.debug ) { console.log ( 'photogram :: destroy()');}

    this.removeAllReferenceAnnotation();
    this.removeEntities();
    
    if ( this.jobAreaEntity ) {
        this.viewer.entities.remove( this.jobAreaEntity );
      }
    
    if (this.refreshStatusInterval) {
      clearInterval(this.refreshStatusInterval);
    }
    this.mapService.selectedReference = undefined;
    this.mapService.loadImages.next(undefined);

    this.clearArea();
    this.removeEntities();

  }

  ngOnChanges(changes) {
    if ( this.debug ) { console.log ( 'photogram :: ngOnChanges()', changes); }
    this.refresh(true);
  }

  initPhotogram(){

    console.log ( 'photogram :: initPhotogram()', this.r.url, this.mapService);

    if ( this.mapService && this.mapService.scene ) {
      if ( this.debug ) { console.log ( 'photogram :: initPhotogram() currentScene', this.mapService.scene); }
      this.currentScene = this.mapService.scene;
    }
    
    if (this.mapService.viewer) {
      if ( this.debug ) { console.log ( 'photogram :: initPhotogram() isViewer'); }
      this.viewer = this.mapService.viewer;
      this.setupViewerPropertyToDrawRectangle();
    }

    this.addSubscription('test',
      this.mapService.transformsFromFolder.subscribe(value => {
        if ( this.debug ) { console.log ( 'photogram :: initPhotogram() transformsFromFolder'); }
        this.plotAllJpegImagesFromFolder(value.id, value);
      })
    );

    if ( this.debug ) { console.log ( 'photogram :: initPhotogram() currentProject', this.mapService.currentProject); }

    // if we're currently in a project
    if (this.mapService.currentProject) {
  
      if ( this.debug ) { console.log ( 'photogram :: initPhotogram() subscribe to PARAMS', this.ar.params); }

      // unfinished; we should add support for multiple jobs
      this.ar.params.subscribe(s => {
        
        if(s.id == 'new'){
          if ( this.debug ) { console.log ( 'photogram :: initPhotogram() isInProject NEW', s); }
          this.createJob();
        }
        else{
          if ( this.debug ) { console.log ( 'photogram :: initPhotogram() isInProject EXISTING', s); }
        }
      })

      // Is there a job associated with the current scene?
      this.checkForJob();

    }
  }

  checkForJob() {

    if ( this.debug ) { console.log ( 'photogram :: checkForJob() for scene', this.currentScene); }

    // When the Job's 'current' isn't 'null'. I don't know what this state is, but I'm assuming a running job?
    this.fourD.V.searchByObject(Job).equals('scene', this.currentScene).notEquals('current', 'null').queryObservable().subscribe(value => {

      if ( this.debug ) {  console.log ( 'photogram :: initPhotogram() get Job where Job.current !== null', value);}

      if (value && value.items.length > 0) {

        if ( this.debug ) { console.log ( 'photogram :: initPhotogram() get Job where Job.current !== null = YES', value.items ); }

        this.currentJob = value.items[0];
        if ( !this.currentJob['hasRunPreview'] ) {
          this.currentJob['hasRunPreview'] = false;
        }
        if ( !this.currentJob['hasRunFull'] ) {
          this.currentJob['hasRunFull'] = false;
        }
        this.selectOutput();
        this.setRefernenceAnnotation();
        this.jobRunning = true;
        this.currentJobName = this.currentJob.name;
        this.refresh(false);
        this.waitForStatus(this.currentJob['isFullProcessing']);

      // no, so we should create one
      // note: 
      } else {

        if ( this.debug ) { console.log ( 'photogram :: initPhotogram() get Job where Job.current !== null = NO, so find latest Job with the scene'); }

        // note: this only finds the latest Job for this scene, and only 1, so this needs a rewrite for when there's more than one job

        this.fourD.V.searchByObject(Job).equals('scene', this.currentScene).sortBy('dateUpdated', true).limit(1).queryObservable().subscribe(value => {
          
          if (value && value.items.length > 0) {

            if ( this.debug ) { console.log ( 'photogram :: initPhotogram() get latest Job = YES, so restore state', value.items ); }

            this.currentJob = value.items[0];
            this.checkInputDatasetsExist();
            this.selectOutput();
            this.currentJobName = this.currentJob.name;
            this.getPDFReport();
            this.refresh(false);
            
            if ( this.currentJob['COORD_FILE'] ) {
              this.showOptionalCoords = true;
            }

            this.getTransformsForCurrentJob().subscribe( items => {

              if ( this.debug ) { console.log ( 'photogram :: initPhotogram() finding getTransformsForCurrentJob()', items ); }

              // yes, there's a few Transforms on it
              if (items && items.length > 0) {

                this.setRefernenceAnnotation();
                this.plotAllJpegImagesFromFolder();

                // hmm, seems redundant
                // this.refresh(true);
                this.canStartFullProcess = true;

                items.forEach(value => {

                  if ( this.debug ) { console.log ( 'photogram :: initPhotogram() finding Transforms, checking out "'+value.name+'" ['+value.id+']', value.transformType.uid, value ); }

                  // check if any of these transforms are preview or full-job files, and set state accordingly
                  this.checkTransformsForState( value );

                  if (value.transformType.uid == 'three-d-tiles' /*&& !value.pointCloudShading*/) {
                    value.pointCloudShading = {
                      'geometricErrorScale': 1,
                      'attenuation': true,
                      'maximumAttenuation': 8,
                      'baseResolution': 0,
                      'eyeDomeLighting': false,
                      'eyeDomeLightingStrength': 1,
                      'eyeDomeLightingRadius': 1
                    }
                    value.saveObservable().subscribe();
                  }
                  this.plottedTransform = value;
                  this.addPlottable(value);

                });
              }
            });

          } else {
            this.createJob();
            // this.resetJobData();
          }
        });
      }
    });
  }
  
  refresh(canRestJobRunning:boolean = false) {
    if ( this.debug ) {  console.log ( 'photogram :: refresh()', this.currentJob);}
    if (this.currentJob) {

      this.batches = this.currentJob.batches()

      let tt = this.currentJob.jobType.baseTransform;

      if ( this.debug ) { console.log ( 'photogram :: refresh() batches', this.batches, tt); }

      forkJoin([
        this.currentJob.inputDatasets.useCache(true).queryObservable(),
        // this.currentJob.inputFolders.useCache(true).queryObservable(),
        this.currentJob.jobType.subTransforms.useCache(true).queryObservable(),
        this.batches.useCache(true).sortBy('dateMade', true).queryObservable(),
        this.currentJob.quoteTransform(tt)
      ]).subscribe(res => {

        if ( this.debug ) { console.log ( 'photogrammetry :: refresh() forkJoin()   @@@@@@@', res ); }
        
        // this.folderAdded = !!res[1].items.length
        this.initalTransform = res[2]['items'].find(cur => cur.transformType == this.currentJob.jobType.baseTransform);

        // this.everything is used for debugging
        this.everything = { 
          inputDatasets: this.fetchFromItems ( res[0]['items'] ),
          subtransform: this.fetchFromItems ( res[1]['items'] ),
          batches: this.fetchFromItems ( res[2]['items'] ),
          price: res[3]
        };

        this.subTransforms = this.fetchFromItems ( res[1]['items'] );

        if (canRestJobRunning) {
          this.jobRunning = false;
        }

        // check if there's a report
        this.getPDFReport();

        // if all images have coords, let's create an overview area from them
        this.createAreaFromImages();

        this.loading = false;

        if ( this.debug ) {  console.log ( 'photogrammetry :: refresh() currentJob   @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', res, this.currentJob ); }
        
      })

    } else {

      this.jobRunning = false;
      this.loading = false;

    }

  }

  getTransformsForCurrentJob() : Observable<any> {

    // string piped with transform id's to fetch
    let ids = this.currentJob['transforms'] ? Array.prototype.map.call(this.currentJob['transforms'], function(item) { 
      if ( item && item.id !== null ) return item.id; 
    }).join("|") : '' ;

    if ( ids.trim() == '' ) {
      if ( this.debug ) { console.log ( 'photogram :: getTransformsForCurrentJob() BLANK strIds="'+ids+'"' ); }
      return of([]);
    }
    
    if ( this.debug ) { console.log ( 'photogram :: getTransformsForCurrentJob() newObs', ids, '!' + this.TYPE_THUMB.id + '&!' + this.TYPE_DZI.id + '&!' + this.XML_BLOCKS.id ); }

    const me = new Observable(subscriber => {

      this.fourD.V.searchByObject(Transform)
      .equals('id', ids)
      .equals('transformType', '!' + this.TYPE_THUMB.id + '&!' + this.TYPE_DZI.id + '&!' + this.XML_BLOCKS.id)
      .queryObservable()
      .subscribe(sub => {

        if ( this.debug ) { console.log ( 'photogram :: getTransformsForCurrentJob() finding Transforms, result', sub.items ); }
        subscriber.next(sub.items);
      });

    });

    return me;
  }

  checkTransformsForState( t:Transform ) {
    let value = (' ' + t.name ).trim().toLowerCase(); 
    if ( this.debug ) { console.log ( 'photogram :: checkTransformsForState() looking in', value ); }
    if (value.indexOf('quickview') !== -1) {
      this.currentJob['hasRunPreview'] = true;
      if ( this.debug ) { console.log ( 'photogram :: checkTransformsForState() FOUND quickview' ); }
    }
    if (value.indexOf('sparsecloud') !== -1) {
      this.currentJob['hasRunPreview'] = true;
      if ( this.debug ) { console.log ( 'photogram :: checkTransformsForState() FOUND sparsepointcloud' ); }
    }
    if ( value.indexOf('ortho-full') !== -1 ) {
      this.currentJob['hasRunFull'] = true;
      if ( this.debug ) { console.log ( 'photogram :: checkTransformsForState() FOUND ortho-full' ); }
    }
    if ( value.indexOf('pointcloud') !== -1 && value.indexOf('pointcloud') < 5 ) {
      this.currentJob['hasRunFull'] = true;
      if ( this.debug ) { console.log ( 'photogram :: checkTransformsForState() FOUND pointcloud' ); }
    }
    if ( value.indexOf('dem.tif') !== -1 ) {
      this.currentJob['hasRunFull'] = true;
      if ( this.debug ) { console.log ( 'photogram :: checkTransformsForState() FOUND DEM.tif' ); }
    }
  }


  // clicking to close the info box
  cancel() {
    this.mapComp.detailsNav.close();
    this.navigateBack(this.location);
  }

  private addPlottable(value) {
    this.plottedTransformFull.push(value);
  }

  private setRefernenceAnnotation() {
    if (this.currentJob[this.mapService.REFERENCE_ANNOTATION]) {
      this.unserializeReferenceAnnotations();
      this.drawAllReferenceAnnotation();
    }
    /*if(this.currentJob[this.mapService.REFERENCE_ANNOTATION_PLOT]){
      this.plotReferenceAnnotation(this.currentJob[this.mapService.REFERENCE_ANNOTATION_PLOT]);
    }*/
  }


  private plotAllJpegImagesFromFolder(folderId?, dest?) {
    if ( this.debug ) { console.log ( 'photogram :: plotAllJpegImagesFromFolder()', folderId, dest); }
    let longitudeArray: Array<number> = [];
    let latitudeArray = [];
    if (this.mapService.localPhotos[this.currentScene.id]) {
      this.plotAllJpeg(this.mapService.localPhotos[this.currentScene.id], longitudeArray, latitudeArray);
    } else {
      this.currentScene.photos
        .limit(10000)
        .queryObservable().subscribe(value => {
        if (value.items && value.items.length > 0) {
          this.plotAllJpeg(value.items, longitudeArray, latitudeArray);
        } else {
          this.openSnackBarError('MAP.PHOTOGRAM.NO_JPEG')
        }

      });
    }

  }

  showHideCoverageArea() {
    if ( this.debug ) { console.log ( 'photogram :: showHideCoverageArea()', this.jobAreaEntity, this.showCoverageArea ); }
    if ( this.jobAreaEntity ) {
      this.jobAreaEntity.show = !this.showCoverageArea;
    }
  }

  private plotAllJpeg(value, longitudeArray: Array<number>, latitudeArray) {

    if ( this.debug ) { console.log ( 'photogram :: plotAllJpeg()', value, longitudeArray, latitudeArray, this.referenceAnnotation ); }

    value.forEach(
      image => {
        if ( image && image.llng ) {
          let lo = image['exif_loc'] ? image['exif_loc']['lng'] : image.llng;
          let la = image['exif_loc'] ? image['exif_loc']['lat'] : image.llat;
          let he = image['exif_loc'] ? image['exif_loc']['height'] : image.uheight;

          this.cameraPositionsFromFolder.push(new Cesium.Cartesian3.fromDegrees(lo, la, he));

          longitudeArray.push(lo);
          latitudeArray.push(la);
          if (this.transformsFromFolder.findIndex(value1 => value1.id === image.id) === -1) {
            this.transformsFromFolder.push(image);
          }
        }

        let imageName = image.name.trim();

        let GCPref = image['markedInPhotogramReference'] ? image['markedInPhotogramReference'] : null;
        if ( GCPref ) {

          let GCP = this.referenceAnnotation.get ( GCPref.imageName );
          // console.log ( 'photogram :: plotAllJpeg() IMAGE name,finder,lut', imageName, GCPref, GCP );

          // the CGP exists
          if ( GCP ) {
            
            // it's list of marked images
            let imgrefs = GCPref.referenceAnnotationMarkedImages;
            
            // does our GCP have none or blank image references? (might not be loaded yet)
            if ( ! GCP.referenceAnnotationMarkedImages ) {
              GCP.referenceAnnotationMarkedImages = [];
            }

            let already_there = GCP.referenceAnnotationMarkedImages.find ( i => { return i.imageName.trim() == imageName });
            // console.log ( 'photogram :: plotAllJpeg() IMAGE imgrefs,already_there', imgrefs, already_there );

            if ( ! already_there ) {
              let f = imgrefs.find ( i => { return i.imageName.trim() == imageName });
              if ( f ) {
                GCP.referenceAnnotationMarkedImages.push(f);
              }; 
              // console.log ( 'photogram :: plotAllJpeg() IMAGE not_there', f, GCP.referenceAnnotationMarkedImages );

            }
            
          }
        }
       //  let find = this.referenceAnnotation.get( finder );
        
        

      }
    );

    if ( longitudeArray.length > 0 ) {

    
      var west = Math.min(...longitudeArray);
      var east = Math.max(...longitudeArray);
      var south = Math.min(...latitudeArray);
      var north = Math.max(...latitudeArray);

      let bottomleft = new Cesium.Cartesian3.fromDegrees(west, south, 100);
      let topright = new Cesium.Cartesian3.fromDegrees(east, north, 100);

      let testArr = [ bottomleft, topright ];
      
      // this.jobArea = Cesium.Rectangle.fromDegrees(west, south, east, north);
      this.jobArea = Cesium.Rectangle.fromCartesianArray(testArr);
      
      // console.log ( 'photogram :: plotAllJpeg()', value, longitudeArray, latitudeArray );

      // if (this.currentJob[this.mapService.DATA_FROM_FOLDER]) {
      //   this.plotEntities(this.cameraPositionsFromFolder, true);
      // }

     // if ( this.jobAreaEntity ) {
     //   this.viewer.entities.remove( this.jobAreaEntity );
     // }

     // this.jobAreaEntity = this.viewer.entities.add ({
     //   rectangle : {
          // show: false,
     //     coordinates : this.jobArea
     //   }
      //});

     // if ( this.debug ) { console.log ( 'photogram :: plotAllJpeg() w/flyTo()', west, [ west, south, east, north ], testArr, this.jobArea, this.jobAreaEntity ); }

     // this.mapService.viewer.flyTo(this.jobAreaEntity);
      // this.sendCamera(this.jobArea);

      /*if (dest) {
        if (this.currentJob) {
          this.currentJob.inputFolders.addObserveable(dest).subscribe(s => {
              this.openSnackBarSuccess(s + ' items added')
              this.currentJob.inputFolders.items.subscribe()
            },
            e => this.openSnackBarError(e)
          )
        }
      }*/
    }

    this.folderAdded = true;
  }

  // isReference really means isControlPoints
  
  importMetadata(isReference: boolean) {
    this.addSubscription('test',
      this.openMetadataDialogWith('PROJECT.DIALOG.ADD_TRANSFORM_TEXT', isReference).subscribe(dest => {

      if ( this.debug ) { console.log ( 'photogram :: importMetadata()', dest, this.transformsFromFolder); }
        if (dest) {
          this.metaDataImported = true;
          if (dest.csvRecords) {
            this.csvRecords = dest.csvRecords;

            if (!isReference) {

              // if not GCPs, ie. these are enhanced coordinates for images

              let localImageErrors = [];
              if (this.transformsFromFolder) {
                this.transformsFromFolder.forEach(localImage => {
                  let localFound = false;

                  let imgName = '';
                  let long = localImage.llng ? localImage.llng : null;
                  let lat = localImage.llat ? localImage.llat : null;

                  dest.csvRecords.forEach(csv => {

                    imgName = (' ' + csv[dest.index.imageIndex]).trim();

                    if ( imgName === ( ' ' + localImage['ds_name'] ).trim() ) {

                      long = csv[dest.index.longitudeIndex];
                      lat = csv[dest.index.latitudeIndex];

                      localFound = true;
                      if ( this.debug ) { console.log ( 'photogram :: importMetadata() IMAGE FOUND', imgName, long, lat); }
                      // return;
                    }
                  });

                  // console.log ( 'photogram :: importMetadata() IMAGE not found', imgName, long, lat);
                      
                  localImage.llng = long;
                  localImage.llat = lat;

                  if (!localFound) {
                    localImageErrors.push(localImage);
                  }

                });
              }

              if (localImageErrors.length > 0) {
                this.openSnackBarError(localImageErrors.length + 'MAP.PHOTOGRAM.IMAGES_ERROR', null);
                this.importMetaDataError = true;
                return;
              } else {
                this.importMetaDataError = false;

                if (dest.cameraPositions && !this.currentJob[this.mapService.DATA_FROM_FOLDER]) {
                  this.removeEntities();
                  this.plotEntities(dest.cameraPositions, false, dest);
                }
                if (dest.rectangle) {
                  this.sendCamera(dest.rectangle);
                }
                if ( dest.canonical ) {
                  this.currentJob['canonical'] = dest.canonical;
                }
                this.currentJob['canonical_camera_coords'] = this.csvRecords;
              }
              if ( this.debug ) { console.log( 'photogram :: importMetadata() RESULT', dest.index, dest.rectangle, this.currentJob['latLongSwap'], this.currentJob); }
              // this.currentJob['index'] = dest.index;

              this.currentJob['metaSaved'] = true;

              this.currentJob['metaIndex'] = {
                "imageIndex": 0,
                "latitudeIndex": !this.currentJob['latLongSwap'] ? 2 : 1,
                "longitudeIndex": !this.currentJob['latLongSwap'] ? 1 : 2,
                "heightIndex": 3,
                "heightAccuracyIndex": 6,
                "latitudeAccuracyIndex": 5,
                "longitudeAccuracyIndex": 4
              };

              this.currentJob.saveObservable().subscribe();

            } else {


              this.removeAllReferenceAnnotation();

              // if the return from the dialogbox is referenceAnnotation (ie. GCPs)
              this.clearReferenceAnnotations();
              
              let i = 0;
              dest.csvRecords.forEach(csv => {
                // clean image names
                csv[dest.index.imageIndex] = csv[dest.index.imageIndex].replace('THUMB', '').replace('JPG_DZI', '').replace('DZI', '').trim();
                this.referenceAnnotation.set ( csv[dest.index.imageIndex], new ReferenceAnnotation(csv[dest.index.imageIndex], dest.cameraPositions[i].y, dest.cameraPositions[i].x, dest.cameraPositions[i].z, true));
                i++;
              });
              
              this.drawAllReferenceAnnotation();
              // this.currentJob[this.mapService.REFERENCE_ANNOTATION_PLOT] = dest.cameraPositions;
              
              this.serializeReferenceAnnotations();

              // this.currentJob['referenceIndex'] = dest.index;

              this.currentJob['gcpSaved'] = true;
              this.currentJob['canonical_gcp_coords'] = this.csvRecords;

              this.currentJob['referenceIndex'] = {
                "imageIndex": 0,
                "latitudeIndex": !this.currentJob['latLongSwap'] ? 2 : 1,
                "longitudeIndex": !this.currentJob['latLongSwap'] ? 1 : 2,
                "heightIndex": 3,
                "heightAccuracyIndex": 6,
                "latitudeAccuracyIndex": 5,
                "longitudeAccuracyIndex": 4
              };

              this.currentJob.saveObservable().subscribe();
            }
            if (this.mapService.scene.folder) {
              this.createDataSetAndUploadFile(this.mapService.scene.folder, dest, isReference);
            } else {
              this.createFolderDatasetAndUploadFile(dest, isReference);
            }
            /*
            from folder all images
              ([0].imagename = for each((csvRecords.imagename){
                csvLat && csvLong && height present

               })else{
               [0].imagename coordinaties not found in csv
               }
               if no error then send the file to backend and can run the job
             */
          } else {
            this.csvRecords = [];
          }
          if (dest === 'clear') {
            this.csvRecords = [];
            // this.folderAdded = false;
            this.currentJob[this.mapService.DATA_FROM_FOLDER] = true;
            // this.currentJob[this.mapService.JOB_EPSG_CODE] = undefined;
            if (!isReference) {
              /*this.currentJob.inputFolders.queryObservable().subscribe(value => {
                value.items.forEach(value1 => {
                  this.currentJob.inputFolders.removeObservable(value1).subscribe();
                })
              });*/
              // this.removeEntities();
              this.cameraPositionsFromFolderID = [];
            } else {
              this.clearReferenceAnnotations();
              this.serializeReferenceAnnotations();
              this.removeAllReferenceAnnotation();
              // this.pinFromReferenceAnnotation = [];
            }
            this.currentJob.saveObservable().subscribe();
            this.removeDatasetFromJob(isReference);
            this.transformsFromFolder = [];
          }

          // if all images have coords, let's create an overview area from them
          this.createAreaFromImages();

        }
      },
      e => {
        this.openSnackBarError(e.message, null);
        this.csvRecords = [];
      }
    ))

  }

  createCoordListOfPhotosFromCSV ( csv:any ) {
    if ( this.currentJob ) {

      let result = [];

      this.currentJob['canonicalCoords'] = result;

    }
  }

  
  private addRectangle() {
    
    if ( this.debug ) { console.log ( 'photogram :: addRectangle()', this.getSelectorLocations ); }
    
    this.selector = this.viewer.entities.add({
      selectable: true,
      show: false,
      rectangle: {
        fill: true,
        height: 0,
        outline: true,
        coordinates: this.getSelectorLocations,
        material: Cesium.Color.RED.withAlpha(0.5)
      }
    });
  }

  createAreaFromImages() {

    if ( this.debug ) { console.log ( '%c photogram :: createAreaFromImages()', Constants._purple, this.currentJob['canonical'] ); }

  }


  private removeDatasetFromJob(isReference: boolean) {

    if ( this.debug ) { console.log ( 'photogram :: removeDatasetFromJob()', isReference); }

    this.addSubscription('test',
      this.currentJob.inputDatasets.queryObservable().subscribe(value => {
        value.items.forEach(value1 => {
          if (isReference && value1.name.indexOf(this.mapService.FOURDDMAPPER_REFERENCE) !== -1) {
            this.currentJob.inputDatasets.removeObservable(value1).subscribe(value2 => {
              value1.destroyObservable().subscribe();
            });
          }
          if (!isReference && value1.name.indexOf(this.mapService.FOURDDMAPPER_REFERENCE) === -1) {
            this.currentJob.inputDatasets.removeObservable(value1).subscribe(value2 => {
              value1.destroyObservable().subscribe();
            });
          }
        })
      }));
  }

  openMetadataDialogWith(title: string, isReference: boolean): Observable<any> {

    let dialogRef = this.dialog.open(MetadataDialogComponent, {
      width: '85%',
      height: '80%',
      data: {
        title: title,
        isReference: isReference,
        currentJob: this.currentJob,
        currentScene: this.currentScene
      }
    });

    return dialogRef.afterClosed()
  }

  openTermsAndConditionDialogWith(currentJob: Job, isFullProcessing: boolean, canSubscribe: boolean) {

    let dialogRef = this.dialog.open(TermsConditionDialogComponent, {
      width: '50%',
      data: {
        currentJob: currentJob,
        isFullProcessing: isFullProcessing,
        gigaPixels: this.gigaPixels,
      }
    });
    if (canSubscribe) {
      this.addSubscription('test',dialogRef.afterClosed().subscribe(dest => {
        if (dest && dest.currentJob) {
          this.currentJob['amountPaid'] = true;
          this.currentJob.saveObservable().subscribe();
        }
        if (dest !== undefined && dest === false) {
          this.currentJob['amountPaid'] = false;
          this.currentJob.saveObservable().subscribe();
        }
      }));
    } else {
      return dialogRef.afterClosed();
    }

  }


  openPaymentDialogWith(currentJob: Job): Observable<any> {

    let dialogRef = this.dialog.open(PaymentComponent, {
      width: '50%',
      height: '60%',
      data: {
        currentJob: currentJob,
      }
    });

    return dialogRef.afterClosed()
  }

  private createFolderDatasetAndUploadFile(dest, isReference: boolean) {

    if ( this.debug ) { console.log ( 'photogram :: createFolderDatasetAndUploadFile()', dest, isReference); }
    
    //if (!this.mapService.currentProject.folder) {
    //  this.createProjectFolderAndProcess(dest, isReference);
    //} else {
      this.createSceneFolderAndProcess(dest, isReference);
    //}
  }

// create a project folder and then create scene folder and upload files
  private createProjectFolderAndProcess(dest, isReference: boolean) {

    if ( this.debug ) {  console.log ( 'photogram :: createProjectFolderAndProcess()', dest, isReference); }

    //if(this.mapService.currentProject.folder){
      this.createSceneFolderAndProcess(dest, isReference);
    /*}
    else{
      var f = new Folder(this.fourD.V).set({
        name: this.mapService.currentProject.name
      });
      f.saveObservable().subscribe(fo => {
        this.mapService.currentProject.folder = fo;
        this.mapService.currentProject.saveObservable().subscribe();
        this.createSceneFolderAndProcess(dest, isReference);
      });
    }*/
  }

// create a scene folder and assign project folder as a parent  and upload files
  private createSceneFolderAndProcess(dest, isReference: boolean) {

    if ( this.debug ) { console.log ( 'photogram :: createSceneFolderAndProcess()', dest, isReference); }

    //if(this.mapService.scene.folder){
      // SJ Should never run  this for new projects / scenes as they should be made by servers
    
      this.createDataSetAndUploadFile(this.mapService.scene.folder, dest, isReference);
    /*}
    else{
      // mode existing ptogoram jobs.
      // so @depicated
      var folder = new Folder(this.fourD.V)
      folder.name = this.mapService.scene.name;
      folder.forScene = this.mapService.scene
      this.mapService.currentProject.projectFolder.subscribe(f => {
        folder.parent = f
        folder.saveObservable().subscribe(
          (f) => {
            this.mapService.scene.folder = f;
            this.mapService.scene.saveObservable().subscribe();
            this.createDataSetAndUploadFile(this.mapService.scene.folder, dest, isReference);
          }
        );
      })
    }*/
  }

  private createDataSetAndUploadFile(sceneFolder: Folder, dest, isReference: boolean) {
    
    if ( this.debug ) { console.log ( 'photogram :: createDataSetAndUploadFile()', sceneFolder, dest, isReference); }

    if (window.navigator.userAgent.indexOf('Edge') > -1) {
      this.openSnackBarWarn('MAP.PHOTOGRAM.FILE_ERROR');
      this.edgeBrowserError = true;
      return;
    } else {
      this.edgeBrowserError = false;
    }
    var blank = new Dataset(this.service.V).set({
      /*name: isReference ? this.currentJob.name + this.mapService.FOURDDMAPPER_REFERENCE : this.currentJob.name,*/
      name: isReference ? this.mapService.FOURDDMAPPER_REFERENCE : this.mapService.FOURDDMAPPER_META,
      folder: sceneFolder
    });

    if ( dest.file && dest.file.name ) {
      if ( isReference ) {
        this.currentJob['REFERENCE_FILE'] = dest.file.name;
      } else {
        this.currentJob['COORD_FILE'] = dest.file.name;
      }
      this.currentJob.saveObservable().subscribe();
    }
    
    blank.saveObservable().subscribe(ds => {
      // var  f = new File(this.csvRecords,ds.name);
      if ( this.debug ) { console.log ( 'photogram :: create...() save blank', blank, ds, dest.csvRecords[0] ); }
      let s = '';
      dest.csvRecords.forEach(value1 => s += value1 + '\n');
      s = s.substr(0, s.lastIndexOf('\n'));
      let data = new Blob([s], {type: 'text'});
      data['name'] = ds.name;
      /*if (window.navigator.userAgent.indexOf('Edge') > -1) {
        this.sendFile(data, ds);
      } else {*/
      let arrayOfBlob = new Array<Blob>();
      arrayOfBlob.push(data);
      let applicationZip = new File(arrayOfBlob, ds.name);
      this.fourD.uploadFile(ds, applicationZip, 'data', 19000000);
      if ( this.debug ) { console.log ( 'photogram :: create...() upload'); }
      // }


      this.currentJob.inputDatasets.queryObservable().subscribe(value1 => {
        if (value1.items.length === 0) {
          this.currentJob.inputDatasets.addObserveable(ds).subscribe();
        } else {
          let replaced = false;
          value1.items.forEach(value2 => {
            if (isReference && value2.name.indexOf(this.mapService.FOURDDMAPPER_REFERENCE) !== -1) {
              this.replaceDataset(value2, ds);
              replaced = true;
            } else if (!isReference && value2.name.indexOf(this.mapService.FOURDDMAPPER_REFERENCE) === -1) {
              this.replaceDataset(value2, ds);
              replaced = true;
            }
          });
          if (!replaced) {
            this.currentJob.inputDatasets.addObserveable(ds).subscribe();
          }
        }
      })
    });
  }

  sendFile(data, dataset: Dataset) {

    console.log ( 'photogram :: sendFile()', data, dataset );


    let imageName = dataset.name + '.json';
    var xhr = new XMLHttpRequest();
    var upload = xhr.upload;
    upload.addEventListener('progress', (evt) => {
      if (evt.lengthComputable) {
        console.log(evt);
      }
    }, false);

    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {

        if (!xhr.responseText || xhr.responseText === '') {
          this.openSnackBarError(Constants.ERROR_MESSAGE);
          return;
        }
        // good response
        var res = JSON.parse(xhr.responseText);
        if (res.status && res.status === 200) {
          {
          }
        } else if (res.status && res.status < 400) {
          console.log('vasat error');
          this.openSnackBarError(Constants.ERROR_MESSAGE);
          // vasat error
        } else {
          this.openSnackBarError(Constants.ERROR_MESSAGE);
          console.log('all good');
        }
      }
    };
    xhr.open('POST', this.mapComp.fourD.V.config.host + '/api/Dataset/' + dataset.id + '/' + imageName);
    xhr.overrideMimeType('application/binary');
    xhr.setRequestHeader('Content-Type', 'application/binary')
    xhr.setRequestHeader('Authorization', 'Bearer ' + this.mapComp.fourD.V.token)
    let d = JSON.stringify(data);
    xhr.send(data);
  }

  private replaceDataset(value2: Dataset, ds) {
    this.currentJob.inputDatasets.removeObservable(value2).subscribe(value3 => {
      value2.destroyObservable().subscribe();
      this.currentJob.inputDatasets.addObserveable(ds).subscribe();
    });
  }

  private sendCamera(rectangle) {
    if ( this.debug ) { console.log ( 'photogram :: sendCamera()', rectangle); }
    var e = this.viewer.entities.add({
      name: 'Green translucent, rotated, and extruded rectangle at height with outline',
      rectangle: {
        coordinates: rectangle,
      }
    });
    this.viewer.zoomTo(e).then(r => {
      if ( this.debug ) { console.log ( 'photogram :: sendCamera() zoomTo', e); }
      e.show = false;
      this.viewer.entities.remove(e);
    });
  }

  private plotEntities(cameraPositions, plotingFromFolder: boolean, dest?: any) {

    if ( this.debug ) { console.log ( 'photogram :: plotEntities()', cameraPositions, plotingFromFolder, dest ); }
      
    let i = 0;
    if (!plotingFromFolder) {
      if (!this.mapService.localPhotos[this.currentScene.id] || this.mapService.localPhotos[this.currentScene.id].length === 0) {
        this.currentScene.photos.limit(10000).queryObservable().subscribe(photo => {
          this.mapService.localPhotos[this.currentScene.id] = photo.items;

          cameraPositions.forEach(value => {
            let localFound = false;
            /*this.transformsFromFolder.forEach(localImage => {
                if (dest.csvRecords[i][dest.index.imageIndex] === localImage.input.name) {
                  localFound = true;
                  return;
                }
              }
            );*/

            if (this.mapService.localPhotos[this.currentScene.id].length !== 0) {
              this.mapService.localPhotos[this.currentScene.id].forEach(localImage => {
                if (dest.csvRecords[i][dest.index.imageIndex] === localImage.input.name) {
                  localFound = true;
                  return;
                }
              });
            }

            i++;
            if (localFound) {
              this.cameraPositionsFromFolderID.push(this.mapService.viewer.entities.add({
                name: 'Cameras',
                position: value,
                ellipsoid: {
                  radii: new Cesium.Cartesian3(1, 1, 1),
                  material: Cesium.Color.YELLOW
                }
              }));
              if ( this.debug ) { console.log('a. plotting ' + dest.csvRecords[i - 1], value); }
            } else {
              if ( this.debug ) { console.log('a. not plotting ' + dest.csvRecords[i - 1], value); }
            }
          })

        })
      } else {

        // let cams = cameraPositions.filter ( )
        cameraPositions.forEach(value => {
          let localFound = false;
          /*this.transformsFromFolder.forEach(localImage => {
              if (dest.csvRecords[i][dest.index.imageIndex] === localImage.input.name) {
                localFound = true;
                return;
              }
            }
          );*/

          let imgName = dest.csvRecords[i][dest.index.imageIndex];

          this.mapService.localPhotos[this.currentScene.id].forEach(localImage => {
            if (imgName === localImage.input.name) {
              localFound = true;
              return;
            }
          });
          i++;

          if (localFound) {
            this.cameraPositionsFromFolderID.push(this.mapService.viewer.entities.add({
              name: 'Cameras',
              position: value,
              point: {
                pixelSize: 13,
                color: Cesium.Color.YELLOW,
                outlineWidth: 5,
                outlineColor: Cesium.Color.BLACK,
              }/* , 
              label: {
                text: 'c'+i+': '+imgName,
                font : '10px sans-serif',
                pixelOffset: new Cesium.Cartesian2(-20, 0)
              } */
            }));
            if ( this.debug ) { console.log('b. plotting ' + dest.csvRecords[i - 1], value ); }
          } else {
            // console.log('b. not plotting ' + dest.csvRecords[i - 1][dest.index.imageIndex]);
          }
        })
      }
    } else {
      cameraPositions.forEach(value => {
        this.cameraPositionsFromFolderID.push(this.mapService.viewer.entities.add({
          name: 'Cameras',
          position: value,
          ellipsoid: {
            radii: new Cesium.Cartesian3(1, 1, 1),
            material: Cesium.Color.PINK
          }
        }));
      })
    }

  }

  private removeEntities() {

    if ( this.debug ) { console.log ( 'photogram :: removeEntities()' ); }
    
    if ( this.jobAreaEntity ) {
      this.mapService.viewer.entities.remove ( this.jobAreaEntity ) ;
    }
    this.cameraPositionsFromFolderID.forEach(value => {
      this.mapService.viewer.entities.remove(value);
    });
    this.cameraPositionsFromFolderID = [];
  }




  // in the template, when a button is clicked to start a job (preview or full)

  runXForm(tt: TransformType, isFullProcessing: boolean) {

    if ( this.debug ) { console.log ( 'photogram :: runXForm()', tt, isFullProcessing ); }

    if (this.mapService.scene._photo_count <= 3) {
      this.openSnackBarWarn('MAP.PHOTOGRAM.PHOTO_MINIMUM');
      return; // cant process if no photos available
    }
    if (this.currentJob['amountPaid']) {
      let uniqueFileNames = [];
      if (this.mapService.localPhotos[this.currentScene.id]) {
        if (!this.metaDataImported && !this.metaDataUploaded && !this.referenceUploaded) {
          for (let p of this.mapService.localPhotos[this.currentScene.id]) {
            if (!p.llng || !p.llat) {
              this.openSnackBarWarn('MAP.PHOTOGRAM.IMPORT_COORDINATES2');
              return;
            }
            if (uniqueFileNames.findIndex(f => f === p.name) !== -1) {
              this.openSnackBarWarn('MAP.PHOTOGRAM.FILE_DUPLICATE');
              return;
            } else {
              uniqueFileNames.push(p.name);
            }
          }
        } /* else if (this.metaDataImported && this.csvRecords.length == 0 && !isFullProcessing) {
          this.openSnackBarWarn('Imported files do not have lat or long');
          return;
        } */
        this.addSubscription('test',this.openTermsAndConditionDialogWith(this.currentJob, isFullProcessing, false).subscribe(dest => {
          if (dest && dest.currentJob) {
            this.currentJob.saveObservable().subscribe(_ => this.processJob(tt, isFullProcessing));

          }
        }))
      } else {
        this.openSnackBarError('MAP.PHOTOGRAM.DATA_RELOAD');
      }
    } else {
      this.openSnackBarError('PLAN.PAYMENT');
    }
  }

  // only called from runXForm (above) : configures the actual process

  processJob(tt: TransformType, isFullProcessing: boolean) {
    if ( this.debug ) { console.log ( 'photogram :: processJob()', tt, isFullProcessing ); }
    this.isFullProcessing = isFullProcessing;
    var onReady: Observable<any> = null

    onReady = tt['needsInput'] ? this.showInputDialogForT({}, tt, isFullProcessing) : observableOf({model: {}})
    
    onReady.subscribe(params => {

      if ( this.debug ) { console.log ( 'photogram :: processJob() after dialog', params ); }

      if (!params) return;

      // params.model.canonical_gcp_coords = this.currentJob['canonical_gcp_coords'];
      // params.model.canonical_camera_coords = this.currentJob['canonical_camera_coords'];

      if (this.selectedAread && this.length && this.height && this.centerX && this.centerY) {
        /*var requestParams = Object.assign({
          width: length,
          height: height,
          center_long: centerX,
          center_lat: centerY,
          batch_id: 'folder_' + this.resultFolder.id
        }, value.model);*/
        if (this.currentJob[this.mapService.JOB_EPSG_CODE] && this.currentJob[this.mapService.JOB_EPSG_CODE] !== '4326' && this.currentJob[this.mapService.JOB_EPSG_CODE_DESC]) {
          var geographicProjection = 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]]';

          // Projx4(sourceProjection, geographicProjection, [+value[longitudeIndex], +value[latitudeIndex]])



          var xy = this.epsgHelper.convert(geographicProjection, this.currentJob[this.mapService.JOB_EPSG_CODE_DESC], [this.centerX, this.centerY]);
          this.centerX = xy[0];
          this.centerY = xy[1];
        }

        params.model.width = this.length;
        params.model.height = this.height;
        params.model.center_long = this.centerX;
        params.model.center_lat = this.centerY;
        params.model.name = this.currentJob.name;
        // params.batch_id = this.length;
      } else {
        if (this.plottedTransform) {
          var pos_ll = new Cesium.Cartesian3.fromDegrees(this.plottedTransform.llng, this.plottedTransform.llat, 0);
          var pos_lr = new Cesium.Cartesian3.fromDegrees(this.plottedTransform.ulng, this.plottedTransform.llat, 0);
          var length = Cesium.Cartesian3.distance(pos_ll, pos_lr);

          var pos_ul = new Cesium.Cartesian3.fromDegrees(this.plottedTransform.llng, this.plottedTransform.ulat, 0);
          var height = Cesium.Cartesian3.distance(pos_ll, pos_ul);

          var centerX = (this.plottedTransform.ulng + this.plottedTransform.llng) / 2 /** 180 / Math.PI*/;
          var centerY = (this.plottedTransform.ulat + this.plottedTransform.llat) / 2 /** 180 / Math.PI*/;
          if (this.currentJob[this.mapService.JOB_EPSG_CODE] && this.currentJob[this.mapService.JOB_EPSG_CODE] !== '4326' && this.currentJob[this.mapService.JOB_EPSG_CODE_DESC]) {
            var geographicProjection = 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]]';

            var xy = this.epsgHelper.convert(geographicProjection, this.currentJob[this.mapService.JOB_EPSG_CODE_DESC], [centerX, centerY]);
            centerX = xy[0];
            centerY = xy[1];
          }
          params.model.width = length;
          params.model.height = height;
          params.model.center_long = centerX;
          params.model.center_lat = centerY;
          params.model.name = this.currentJob.name;

        }
      }
      /*if(this.csvRecords && this.csvRecords.length > 0){
        this.sendFile();
      }*/


      params.model.referenceIndex = this.currentJob['referenceIndex'];
      params.model.metaIndex = this.currentJob['metaIndex'];
        

      if (isFullProcessing) {

        params.model.doTMS = this.currentJob['doTMS'];
        params.model.doLAZ = this.currentJob['doLAZ'];
        params.model.doTile = this.currentJob['doTile'];
        params.model.doDEM = this.currentJob['doDEM'];

        
        if (this.referenceAnnotation) {
          let s = '';

          this.referenceAnnotation.forEach(function(rr, key) {
            if (rr.referenceAnnotationMarkedImages && rr.referenceAnnotationMarkedImages.length > 0) {
              rr.referenceAnnotationMarkedImages.forEach(rMI => {
                rMI.imageName = rMI.imageName.replace('THUMB', '').replace('JPG_DZI', '').replace('DZI', '').trim();
                /* if (rMI.imageName.indexOf('THUMB') !== -1) {
                   rMI.imageName = rMI.imageName.replace(' THUMB', '');
                 }*/
                /* if (rMI.imageName.indexOf('DZI') !== -1) {
                   rMI.imageName = rMI.imageName.replace(' DZI', '');
                 }*/

                s += rr.imageName + ',' + rMI.imageName + ',' + rMI.pixelX + ',' + rMI.pixelY + ',' + (rr.turnOn ? 1 : 0) + '\n';
              })
            }
          }, this );

          if (s.length > 0) {

            var blank = new Dataset(this.service.V).set({
              name: this.mapService.FOURDDMAPPER_REFERENCE_TICK
            });

            params.model['control_points'] = s.substr(0, s.lastIndexOf('\n'));
            /*
            blank.saveObservable().subscribe(ds => {
              // var  f = new File(this.csvRecords,ds.name);
              s = s.substr(0, s.lastIndexOf('\n'));
              let data = new Blob([s], {type: 'text'});ng
              let arrayOfBlob = new Array<Blob>();
              arrayOfBlob.push(data);
              let applicationZip = new File(arrayOfBlob, ds.name);

              this.fourD.uploadFile(ds, applicationZip, 'data', 19000000);
              this.currentJob.inputDatasets.equals('name',this.mapService.FOURDDMAPPER_REFERENCE_TICK ).queryObservable().subscribe(inputDatasets => {
                  inputDatasets.items.forEach(item => {
                    this.currentJob.inputDatasets.removeObservable(item).subscribe();
                    item.destroyObservable().subscribe();
                  })
                  this.currentJob.inputDatasets.addObserveable(ds).subscribe();
                this.currentJob.inputDatasets.queryParams = {limit: this.currentJob.inputDatasets.queryParams.limit};
              },error1 => {
                this.currentJob.inputDatasets.addObserveable(ds).subscribe();
                this.currentJob.inputDatasets.queryParams = {limit: this.currentJob.inputDatasets.queryParams.limit};
              })
            });
            */
          } else {
            this.currentJob.inputDatasets.equals('name', this.mapService.FOURDDMAPPER_REFERENCE_TICK).queryObservable().subscribe(inputDatasets => {
              inputDatasets.items.forEach(item => {
                this.currentJob.inputDatasets.removeObservable(item).subscribe();
                item.destroyObservable().subscribe();
              })
              this.currentJob.inputDatasets.queryParams = {limit: this.currentJob.inputDatasets.queryParams.limit};
            }, error1 => {
              this.currentJob.inputDatasets.queryParams = {limit: this.currentJob.inputDatasets.queryParams.limit};
            })
          }
        }
      } else {



        // filename, long, lat, height
        // lat = northing, long = east


      }

      params.model.rollingShutter = this.currentJob['rollingShutter'] ? this.currentJob['rollingShutter'] : false;
      params.model.bareEarth = this.currentJob['bareEarth'] ? this.currentJob['bareEarth'] : false;
      
      if (this.currentJob[this.mapService.JOB_REF_EPSG_CODE]) {
        params.model[this.mapService.JOB_EPSG_CODE] = this.currentJob[this.mapService.JOB_REF_EPSG_CODE];
        // params.model[this.mapService.JOB_EPSG_CODE_DESC] = this.currentJob[this.mapService.JOB_REF_EPSG_CODE_DESC];
      } else if (this.currentJob[this.mapService.JOB_EPSG_CODE]) {
        params.model[this.mapService.JOB_EPSG_CODE] = this.currentJob[this.mapService.JOB_EPSG_CODE];
        // params.model[this.mapService.JOB_EPSG_CODE_DESC] = this.currentJob[this.mapService.JOB_EPSG_CODE_DESC];
      } else {
        params.model[this.mapService.JOB_EPSG_CODE] = '4326';
        // params.model[this.mapService.JOB_EPSG_CODE_DESC] = 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]]';
      }


      /*if(this.currentJob[this.mapService.REFERENCE_ANNOTATION]){
        params.model[this.mapService.REFERENCE_ANNOTATION] = this.currentJob[this.mapService.REFERENCE_ANNOTATION];
      }*/
      let pass = tt;

      if (params.bypassPreview) {
        this.currentJob.jobType.subTransforms.queryObservable().subscribe(value => {
          if ( this.debug ) { console.log ( 'photogram :: processJob() bypassingPreview, using Transform id, instead of id', pass.id, value.items[0].id ); }
          pass = value.items[0];
          this.startTransform(pass, params, isFullProcessing);
        });
      } else {
        this.startTransform(pass, params, isFullProcessing);
      }
    })
  }

  // only called from processJob() above: actually runs the job
  // pass = transformType

  private startTransform(pass, params, isFullProcessing: boolean) {

    if ( this.debug ) { console.log ( 'photogram :: startTransform()', pass, params, isFullProcessing ); }
    
    //todo: dont commit with return
    // return;
    //if its not a free job then only send units
    if (!this.currentJob.jobType['hasFree']) {
      if (!isFullProcessing) {
        if ((this.gigaPixels * 3) < 25) {
          params.model.units = 5;
        } else {
          params.model.units = this.gigaPixels * 3 / 5;
        }
      } else {
        if (this.currentJob['doTile']) {
          if ((this.gigaPixels * 2) < 25) {
            params.model.units = 5;
          } else {
            params.model.units = this.gigaPixels * 2;
          }
        } else {
          if ((this.gigaPixels) < 25) {
            params.model.units = 5;
          } else {
            params.model.units = this.gigaPixels;
          }

        }
      }
    }
    this.currentJob['isFullProcessing'] = isFullProcessing;
    this.currentJob['lastParamsSent'] = params.model;
    
    this.currentJob.saveObservable().subscribe(_ => {
      this.currentJob.startTransform(pass, params.model).subscribe(s => {
          this.selectedAread = false;
          this.openSnackBarInfo('MAP.PHOTOGRAM.JOB_STARTED');
          this.jobRunning = true;
          this.csvRecords = [];
          this.batchUpdate = false;
          this.waitForStatus(isFullProcessing);
        }
        ,
        e => {
          this.openSnackBarError('GENERIC.ERROR ' + e.message);
          this.csvRecords = [];
        }
      )
    });
  }

  selectArea() {
    this.selectionEnabled = true;
    this.enableRotate(false);
  }


  private setupViewerPropertyToDrawRectangle() {

    if ( this.debug ) { console.log ( 'photogram :: setupViewerPropertyToDrawRectangle()' ); }

    this.viewer.scene.screenSpaceCameraController.enableTranslate = false;
    // this.viewer.scene.screenSpaceCameraController.enableTilt = false;
    this.viewer.scene.screenSpaceCameraController.enableLook = false;
    this.viewer.scene.screenSpaceCameraController.enableCollisionDetection = false;
    // this.viewer.imageryLayers.get(0).brightness = 0.7;

    this.screenSpaceEventHandler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
    this.camera = this.viewer.camera;
    this.helper = new FourdCesiumHelper(this.fourD, this.viewer)
    this.handler = new Cesium.ScreenSpaceEventHandler(this.viewer.canvas);
    this.scene = this.viewer.scene;

    this.myCallback = this.getSelectorLocation.bind(this);
    this.getSelectorLocations = new Cesium.CallbackProperty(this.myCallback, false);

    this.handleMouseMove();
    this.handleLeftDown();
    this.handleLeftUp();
    //Hide the selector by clicking anywhere
    this.handleRightClick();

    this.addRectangle();
    
  }

  private handleRightClick() {
    this.screenSpaceEventHandler.setInputAction(() => {
      this.clearArea();
    }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
  }

  clearArea() {
    this.selectionEnabled = false;
    if ( this.selector) 
      this.selector.show = false;
    this.resetSelectedArea();
    this.enableRotate(true);
    this.clickedButton = -1;
    this.mapService.selectedReference = undefined;
    this.currentWorkingReferenceAnnotation = undefined;
  }

  private resetSelectedArea() {
    this.length = undefined;
    this.height = undefined;
    this.centerX = undefined;
    this.centerY = undefined;
  }

  private enableRotate(value: boolean) {
    this.mapService.viewer.scene.screenSpaceCameraController.enableRotate = value;
  }

  private handleLeftUp() {
    this.screenSpaceEventHandler.setInputAction(() => {
      if (this.selectionEnabled) {
        this.mouseDown = false;
        this.firstPointSet = false;
        this.selector.rectangle.coordinates = this.rectangleSelector;
        this.selector.rectangle.extrudedHeight = 20;
        this.selector.rectangle.height = 0;
        this.selector.rectangle.outline = true;
        this.selector.rectangle.outlineColor = Cesium.Color.BLACK;
        var pos_ll = new Cesium.Cartesian3.fromRadians(this.rectangleSelector.west, this.rectangleSelector.south, 0);
        var pos_lr = new Cesium.Cartesian3.fromRadians(this.rectangleSelector.east, this.rectangleSelector.south, 0);
        this.length = Cesium.Cartesian3.distance(pos_ll, pos_lr);

        var pos_ul = new Cesium.Cartesian3.fromRadians(this.rectangleSelector.west, this.rectangleSelector.north, 0);
        this.height = Cesium.Cartesian3.distance(pos_ll, pos_ul);

        this.centerX = (this.rectangleSelector.east + this.rectangleSelector.west) / 2 * 180 / Math.PI;
        this.centerY = (this.rectangleSelector.north + this.rectangleSelector.south) / 2 * 180 / Math.PI;

        console.log('centerX', this.centerX);
        console.log('centerY', this.centerY);
        console.log(this.selector.rectangle.coordinates);

        if (this.toPlacOnCesium.length > 0 && (this.centerX - this.toPlacOnCesium[0]['llng'] >= 0 ||
          this.centerX - this.toPlacOnCesium[0]['ulng'] >= 0 ||
          this.centerY - this.toPlacOnCesium[0]['llat'] >= 0 ||
          this.centerY - this.toPlacOnCesium[0]['ulat'] >= 0)) {
          this.selectedAread = true;
          console.log('llng', this.toPlacOnCesium[0]['llng']);
          console.log('ulng', this.toPlacOnCesium[0]['ulng']);
          console.log('llat', this.toPlacOnCesium[0]['llat']);
          console.log('llat', this.toPlacOnCesium[0]['ulat']);
          // this.processFullView(length, height, centerX, centerY);

        } else {
          this.selectedAread = false;
          console.log('Please select area inside the quick view');
        }
        // this.selectedAread = true;
        this.enableRotate(true);
        this.selectionEnabled = false;
      }
    }, Cesium.ScreenSpaceEventType.LEFT_UP);
  }

  private handleLeftDown() {
    this.screenSpaceEventHandler.setInputAction(() => {
      if (this.selectionEnabled) {
        this.mouseDown = true;
        this.selector.rectangle.coordinates = this.getSelectorLocations;
      }
    }, Cesium.ScreenSpaceEventType.LEFT_DOWN);
  }

  private handleMouseMove() {
    this.screenSpaceEventHandler.setInputAction((movement) => {
      if (this.selectionEnabled) {
        if (!this.mouseDown) {
          return;
        }

        this.cartesian = this.camera.pickEllipsoid(movement.endPosition, this.viewer.scene.globe.ellipsoid, this.cartesian);

        if (this.cartesian) {
          //mouse cartographic
          this.tempCartographic = Cesium.Cartographic.fromCartesian(this.cartesian, Cesium.Ellipsoid.WGS84, this.tempCartographic);

          if (!this.firstPointSet) {
            Cesium.Cartographic.clone(this.tempCartographic, this.firstPoint);
            this.firstPointSet = true;
          }
          else {
            this.rectangleSelector.east = Math.max(this.tempCartographic.longitude, this.firstPoint.longitude);
            this.rectangleSelector.west = Math.min(this.tempCartographic.longitude, this.firstPoint.longitude);
            this.rectangleSelector.north = Math.max(this.tempCartographic.latitude, this.firstPoint.latitude);
            this.rectangleSelector.south = Math.min(this.tempCartographic.latitude, this.firstPoint.latitude);
          }
          if (this.selectionEnabled) {
            this.selector.show = true;
          }
        }
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }


  getSelectorLocation(time, result) {
    return Cesium.Rectangle.clone(this.rectangleSelector, result);
  }


  showInputDialogForT(model: any, tt: TransformType, isFullProcessing: boolean) {
    let dialogRef = this.dialog.open(APIDialog, {

      // height: '80%',
      data: {model: model, apis: [tt], title: 'TYPES.' + tt.uid, isFullProcessing: isFullProcessing, aboutToProcess:true }
    });

    return dialogRef.afterClosed()
  }

  private waitForStatus(isFullProcessing: boolean) {
    /*
    cmd: "job_batch_update"
    payload:
    id: 6
    info: "processing"
    job_id: 15
    job_name: "1126"
    name: "Tue Feb 12 01:03:01 UTC 2019"
    status: "processing"
     */

    if ( this.debug ) { console.log ( 'photogram :: waitForStatus()', isFullProcessing ); }
    this.currentJob['lastJobStatus'] = 'OK';

    this.currentJob.saveObservable().subscribe();
    
    this.fourD.onSocketCommand('job_batch_update').subscribe(value => {

      if (value && value.job_id !== this.currentJob.id  ) {
        return;
      }

      if ( this.debug ) { console.log ( 'photogram :: waitForStatus() incoming', value ); }
      
      if ( (value.info.toLowerCase() === 'finished' || value.status.toLowerCase() === 'finished' || value.info.toLowerCase() === 'failed' || value.status.toLowerCase() === 'failed')) {
        if ( this.debug ) { console.log ( 'photogram :: waitForStatus() yup, it is for me', value );this.progressPercent = undefined; }
        this.timeLeft = undefined;

        this.getPDFReport();

        // load the latest versions of the Job object
        this.currentJob.fetchObservable().subscribe();

        if (!this.batchUpdate) {
          this.batchUpdate = true;
          if (!(value.info.toLowerCase() === 'failed' || value.status.toLowerCase() === 'failed')) {
            // this.getPDFReport();
            // this.currentJob['lastJobStatus'] = 'ok';
            this.canStartFullProcess = true;
            if (this.batchUpdate) {
              this.fourD.V.searchByObject(JobBatch).equals('id', value.id).queryObservable().subscribe(res =>
                res.items[0].outputs.queryObservable().subscribe(files => {
                    if (files.items && files.items.length > 0) {
                      this.toPlacOnCesium[0] = files.items[0];
                      this.jobRunning = false;
                      this.pdfRefport = files.items.filter(f => f.name.indexOf('pdf') !== -1)[0]; 

                    } else {
                      this.openSnackBarError('MAP.PHOTOGRAM.JOB_FAILURE');
                      this.currentJob['lastJobStatus'] = 'no_result';
                      this.jobRunning = false;
                    }

                    this.checkForJob();
                    
                  },
                  error1 => {
                    this.jobRunning = false;
                  }
                )
              )
            }

          } else {
            this.openSnackBarError('MAP.PHOTOGRAM.JOB_FAILED');
            this.jobRunning = false;
            this.currentJob['lastJobStatus'] = value.status.toLowerCase();
            this.currentJob['lastJobReport'] = value;
          }
        }
      } else if ( value.progress ) {
        let allProgress = value.progress.split(',');
        if (allProgress[0]) {
          this.progressPercent = parseInt(allProgress[0]);
          if (this.progressPercent == 100) {
            this.progressPercent = 0;
            this.progressStage++;
          }
        }
        if (allProgress[1]) {
          this.timeLeft = allProgress[1];
        }
        if ( value.info.toLowerCase() === 'queued' ) {
          this.progressPercent = 0
        }
          // progress: "Progress: 55.27%, Time left: 11 seconds"
        }
      }
    );
   // this.mapComp.waitForPhotogrammetryJobResult();
  }


  private getTransformFromJobAndPlot(dataset: Dataset, files, folder) {

    if ( this.debug ) { console.log ( 'photogram :: getTransformFromJobAndPlot()', dataset, files, folder ); }
  
    if (!this.xmlDatasetType || !this.pdfDatasetType ||
      (this.xmlDatasetType && dataset.dataType && dataset.dataType.uid !== this.xmlDatasetType.uid) && (this.pdfDatasetType && dataset.dataType && dataset.dataType.uid !== this.pdfDatasetType.uid) &&
      (this.textDatasetType && dataset.dataType && dataset.dataType.uid !== this.textDatasetType.uid)
    ) {
      this.fourD.V.searchByObject(Transform).equals('input', dataset.id)
      // .equals('transformType', '!' + this.TYPE_THUMB.id + '&!' + this.TYPE_DZI.id
      //   + '&!' + this.XML_BLOCKS.id)
        .queryObservable()
        .subscribe(s => {
          if (s.items.length === 0) {
            setTimeout(() => {
              this.getTransformFromJobAndPlot(dataset, files, folder);
            }, 10000);

          } else {
            //getting 403 so putting some delay before plotting on cesium so the all the files get uploaded on S3
            setTimeout(() => {
              if (this.transformsFromFolder) {
                this.transformsFromFolder.forEach(l => {
                  this.mapService.helper.removePlottable(l);
                });
              }
              if (this.plottedTransformFull && this.plottedTransformFull.length > 0) {
                this.plottedTransformFull.forEach(v => {
                  this.mapService.helper.removePlottable(v);
                });
                this.plottedTransformFull = [];
              }

              let previewPresent = false;
              let fullPresent = false;
              /* s.items.forEach(value => {
                 if (value.llng == null || value.llat == null) {
                   console.log('cound not get llng llat so trying again ', dataset.name);
                 } else {
                   if (value.transformType.uid == 'three-d-tiles' /!*&& !value.pointCloudShading*!/) {
                     value.pointCloudShading = {
                       'geometricErrorScale': 1,
                       'attenuation': true,
                       'maximumAttenuation': 8,
                       'baseResolution': 0,
                       'eyeDomeLighting': false,
                       'eyeDomeLightingStrength': 1,
                       'eyeDomeLightingRadius': 1
                     }
                     value.saveObservable().subscribe();
                   }
                   // this.plotTransform(value, fullPresent);
                 }
                 /!*if (this.mapService.sceneTransforms.findIndex(st => st.id === value.id) === -1) {
                   this.mapService.scene['layerProps'][MapService.TOGGLE + value.id] = true;
                   this.mapService.scene.saveObservable().subscribe();
                   this.mapService.sceneTransforms.push(value);
                 }*!/
               })*/
              this.mapService.loadScene(this.mapService.scene.id).subscribe();
              this.jobRunning = false;
            }, 30 * 1000);
            // }
          }
        });
    }
  }

  private plotTransform(value, fullPresent: boolean) {
    if ( this.debug ) { console.log('photogram :: plotTransform()  ' + value.name, fullPresent); }
    this.plottedTransform = value;
    this.plottedTransformFull.push(value);
    this.mapService.helper.addPlottable(value
    ).subscribe(value2 => {
    });
    this.mapService.helper.sendCameraTo(value
    ).subscribe();
  }

  /* private sendFile() {
     let d = new Date();
     let imageName = 'Meta.txt';

     var xhr = new XMLHttpRequest();
     var upload = xhr.upload;
     upload.addEventListener('progress', (evt) => {
       if (evt.lengthComputable) {
         /!* self.progress = ((self.loaded + evt.loaded) / self.total);
          self.progressSubject.next(self.progress)*!/
         console.log(evt);
       }
     }, false);

     xhr.onreadystatechange = () => {
       if (xhr.readyState === XMLHttpRequest.DONE) {

         if (!xhr.responseText || xhr.responseText === '') {
           this.snackBar.open(Constants.UPLOAD_ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
           // this.openSnackBarSuccess(Constants.ERROR_MESSAGE);
           // error
           return;
         }
         // good response
         var res = JSON.parse(xhr.responseText);
         if (res.status && res.status === 200) {
           {
             this.snackBar.open(Constants.UPLOAD_SUCCESS_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
             // this.openSnackBarSuccess(Constants.SUCCESS_MESSAGE);
             this.fileUploaded = true;
           }
           console.log('all good');
           // all good
         } else if (res.status && res.status < 400) {
           console.log('vasat error');
           this.snackBar.open(Constants.UPLOAD_ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
           // this.openSnackBarSuccess(Constants.ERROR_MESSAGE);
           // vasat error
         } else {
           this.snackBar.open(Constants.UPLOAD_ERROR_MESSAGE, '', {duration: Constants.SNACKBAR_DURATION});
           // this.openSnackBarSuccess(Constants.ERROR_MESSAGE);
           console.log('all good');
           // all good
         }
       }
     };

     xhr.open('POST', this.fourD.V.config.host + '/api/Job/' + this.currentJob.id + '/' + imageName);
     xhr.overrideMimeType('text/plain');
     xhr.setRequestHeader('Content-Type', 'text/plain')
     xhr.setRequestHeader('Authorization', 'Bearer ' + this.fourD.V.token)
     xhr.send(this.csvRecords.toString());
   }
 */
  public flyToAnnotation(r: ReferenceAnnotation) {

    if ( this.debug ) { console.log ( 'photogram :: flyToAnnotation()', r ); }
  
    this.currentWorkingReferenceAnnotation = r;
    var arr = Cesium.Cartographic.fromCartesian(Cesium.Cartesian3.fromElements(r.long, r.lat, r.height));
    this.viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromRadians(arr.longitude, arr.latitude, arr.height + 10),
    });


    this.mapService.selectedReference = {
      pos: (arr.longitude
        // *Math.PI / 180
      ) + ';' + (arr.latitude
        // *Math.PI / 180
      ) + ';' + arr.height,
      referenceAnnotation: r,
      job: this.currentJob
    };
    this.mapService.loadImages.next({
      pos: (arr.longitude
        // *Math.PI / 180
      ) + ';' + (arr.latitude
        // *Math.PI / 180
      ) + ';' + arr.height,
      referenceAnnotation: r
    });
    this.mapService.refreshPhotos(arr).subscribe();
    /*this.router.navigate(['images'], {
      relativeTo: this.route,
      queryParams: {pos: r.long + ';' + r.lat + ';' + r.height}
    })*/
  }

  // for backwards compatibility with old jobs that used an array
  convertReferenceArrayToMap () {
    const arr = this.referenceAnnotation;
    this.referenceAnnotation = new Map();
    arr.forEach ( p => {
      this.referenceAnnotation.set (p.imageName, p );
    });
    if ( this.debug ) { console.log ( 'CONVERTED FROM,TO', arr, this.referenceAnnotation); }
  }

  private drawAllReferenceAnnotation() {

    if ( this.referenceAnnotation instanceof Array ) {
      this.convertReferenceArrayToMap();
    }

    if ( this.debug ) { console.log ( 'photogram :: plotReferenceAnnotation()', this.referenceAnnotation ); }
   
      this.viewer.dataSources.add(this.annotationDataSource);

      this.referenceAnnotation.forEach(function(p, key) {

        let pin = {
          name: 'GCP ' + p.imageName,
          position: Cesium.Cartesian3.fromElements(p.long, p.lat, p.height),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.TOP,
          disableDepthTestDistance: 20,
          billboard: {
            image: InspectionComponent.getPinImg('crosshairs', 'blue'),
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM
          }
        }
        let tmp = this.annotationDataSource.entities.add(pin);
        p.entityObj = null;
        p.entityRef = tmp.id;
        // pin['entityRef'] = p.entityRef;
        p.pinRef = null;

        // pin['entityRef'] = entityRef;

        // this.entitiesRefGCP.set ( p.imageName, p.entityRef );

        // this.pinFromReferenceAnnotation.push(pin);
        // this.annotationDataSource.entities.add(pin);
      }, this );

      this.showOptionalControlPoints = false;
      if ( this.referenceAnnotation.size > 0 ) {
        this.showOptionalControlPoints = true;
      }
  }

  private removeAllReferenceAnnotation() {

    // despite its name, it deletes all referenceAnnotations, not just one (sigh)
    console.log ( 'photogram :: removeAllReferenceAnnotation()', this.referenceAnnotation );

      this.referenceAnnotation.forEach(function(pin, key) {
        this.annotationDataSource.entities.removeById(pin.entityRef);
        this.referenceAnnotation.delete ( key );
      }, this );
  
      if ( this.referenceAnnotation.size != 0 ) {
        console.error ( 'Annotations left in the table. Something smells funny.');
      }

  }

  deleteGCP ( r: ReferenceAnnotation ) {
    
    let key = r.imageName;
    console.log ( 'photogram :: deleteGCP()', key, r );
   
    // if ( this.referenceAnnotation instanceof Map ) {

      let pin = this.referenceAnnotation.get ( key );
      if ( pin ) {
        console.log ( 'photogram :: deleteGCP()', key, pin );
        this.annotationDataSource.entities.removeById(pin.entityRef);
        this.referenceAnnotation.delete ( key );
      }

    // }

/*
    let find = this.pinFromReferenceAnnotation.find( pin => { pin.id == r.id });
    if ( find ) {

      this.pinFromReferenceAnnotation.filter ( pin => { return pin.id !== r.id });
    }
*/
  }

  private resetJobData() {

    console.log ( 'photogram :: resetJobData()' );
   
    this.currentJob = undefined;
    this.currentJobName = undefined;
    this.removeAllReferenceAnnotation();
    this.removeEntities();
    this.cameraPositionsFromFolderID = [];
    this.folderAdded = false;
    this.clearReferenceAnnotations();
    this.selectionEnabled = false;
    this.jobRunning = false;
    this.canStartFullProcess = false;
  }

  private createJob() {

    console.log ( 'photogram :: createJob()' );
   
    var jobtype = this.fourD.jobTypes.filter(j => j['uid'] == 'Photogrammetry')[0];
    if (!jobtype) {
      this.openSnackBarError('MAP.PHOTOGRAM.PHOTOGRAMMETRY_TYPE')
      return;
    }
    var job = new Job(this.fourD.V).set({
      name: this.currentScene.name,
      account: this.fourD.activeTeam,
      jobType: jobtype,
      scene: this.mapService.scene,
      group: this.currentScene,
      amountPaid: true,
      DATA_FROM_FOLDER: true,
      hasRunPreview: false,
      hasRunFull: false

    }).saveObservable().subscribe(res1 => {
      this.currentJob = res1;
      this.selectOutput();
      this.currentJobName = this.currentJob.name;
      this.refresh(true);
      // this.openSnackBarSuccess('GENERIC.SAVED');
      this.removeEntities();
      this.removeAllReferenceAnnotation();
      this.canStartFullProcess = false;
      this.folderAdded = true;
      this.jobRunning = false;
      this.plotAllJpegImagesFromFolder();
    });
  }

  requestPayment(cb: Function) {
    this.btInstance.requestPaymentMethod((err, res) => {
      if (err) this.openSnackBarError(err.message)

      else cb(res)

    })
  }

  pay() {
    this.proceesingPay = true;
    document.getElementById('payWrapper').hidden = false;
    this.fourD.V.searchByObject(BillingSetup)
      .equals('account', this.fourD.activeTeam.id)
      .equals('active', true)
      .queryObservable().pipe(
      tap(b => {
        if (b.items.length) {
          this.billingSetup = b.items[0]
          if (this.billingSetup['bt_id']) {
            this.fourD.V.api(this.fourD.V.pathPrefix + '/BillingSetup/' + this.billingSetup.id + '?token=true')
              .subscribe(r =>
                BTDropIn.create({
                  authorization: r.token,
                  container: '#bt-dropin'
                }, (err, instance) => {
                  this.btInstance = instance
                  document.getElementById('submit-button').hidden = false;
                })
              )
          } else {
            this.openSnackBarError('PLAN.BILLING_ACCOUNT');
            this.proceesingPay = false;
          }

        } else {
          this.openSnackBarError('PLAN.BILLING_ACCOUNT');
          this.proceesingPay = false;
        }

      })
    ).subscribe(value => {
      console.log(value)
    }, error1 => {
      this.proceesingPay = false;

    })
  }

  submitPayment() {
    this.requestPayment((res) => {
      this.currentJob.makePayment(res.nonce).subscribe(res => {
          /*if(res){
            this.openSnackBarInfo('You can run the job now');
            this.amountPaid = true;

          }else{
            this.openSnackBarInfo('Transaction failed. Please try again');
            this.amountPaid = false;
          }*/
          this.openSnackBarInfo('MAP.PHOTOGRAM.JOB_RUN');
          this.currentJob['amountPaid'] = true;
          this.currentJob.saveObservable().subscribe();
          this.proceesingPay = false;
        }
        , e => {
          this.openSnackBarError(e.message);
          this.proceesingPay = false;

        }
      )
      console.log(res)
    })
  }

  serializeReferenceAnnotations() {
    // console.log ( 'serialize',this.currentJob[this.mapService.REFERENCE_ANNOTATION], this.referenceAnnotation.entries());
    this.currentJob[this.mapService.REFERENCE_ANNOTATION] = JSON.stringify([...this.referenceAnnotation.entries()]);
  }

  unserializeReferenceAnnotations() {
    const data = this.currentJob[this.mapService.REFERENCE_ANNOTATION];
    let parsed = [];
    let mapped = null;
    try {
      parsed = JSON.parse ( data );
      mapped = new Map ( parsed );
      this.referenceAnnotation = mapped;
    } catch (error) {
      
    }
    
    // console.log ( 'unserialize', data, JSON.parse ( data ));
    
  }

  clearReferenceAnnotations() {
    this.referenceAnnotation.clear();
  }

  saveReference() {
    console.log( 'photogram :: saveReference()', this.referenceAnnotation);

    this.serializeReferenceAnnotations();
    this.currentJob.saveObservable().subscribe();
  }

  selectOutput() {
    if (this.mapService.scene._photo_count < 1) {
      this.openSnackBarWarn('MAP.PHOTOGRAM.JOB_PREREQUISITE');
      return; // cant process if no photos available
    }
    if (this.currentJob['doTMS'] === undefined) {
      this.currentJob['doTMS'] = true;
    }
    if (this.currentJob['doLAZ'] === undefined) {
      this.currentJob['doLAZ'] = true;
    }
    if (this.currentJob['doTile'] === undefined) {
      this.currentJob['doTile'] = false;
    }
    if (this.currentJob['doDEM'] === undefined) {
      this.currentJob['doDEM'] = true;
    }
    /*if(this.currentJob['amountPaid']){
      if(!this.mapService.showPhotos[this.mapService.scene.id]){
        this.mapService.showHideAllPhotosSub.next(true);
      }
      return;
    }*/
    if (this.mapService.localPhotos[this.currentScene.id]) {
      if (!this.mapService.showPhotos[this.mapService.scene.id]) {
        this.mapService.showHideAllPhotosSub.next(true);
      }
      this.calculateGigaPixelsAndOpenTermsDialog();
    } else {
      if (!this.mapService.showPhotos[this.mapService.scene.id]) {
        this.mapService.showHideAllPhotosSub.next(true);
      }
      this.addSubscription('test',this.mapService.localPhotosReadySub.subscribe(_ => {
        this.calculateGigaPixelsAndOpenTermsDialog();
      }))
    }

  }

  private calculateGigaPixelsAndOpenTermsDialog() {
    let photoDimensions = this.mapService.localPhotos[this.currentScene.id].find(photo => photo.dimensions);
    if (photoDimensions) {
      this.gigaPixels = +(photoDimensions.dimensions.width * photoDimensions.dimensions.height / 1000000000 * this.mapService.localPhotos[this.currentScene.id].length).toFixed(2);
      // this.openTermsAndConditionDialogWith(this.currentJob, false, true)
    } else {
      // this.openTermsAndConditionDialogWith(this.currentJob, false, true)
    }
  }

  payment() {
    this.openPaymentDialogWith(this.currentJob).subscribe(dest => {
    })
  }

  clickedMap(movement: any, rightClick: boolean, checkedPosition) {
    // console.log('photogram.comp :: clickedMap()');
    // dont duplicate, just have the list view handle the clicks
    return this.mapComp.imageComp.clickedMap(movement, rightClick, checkedPosition)
  }

  doNothing(r) {
    console.log(r.turnOn)
    // r.turnOn = !r.turnOn;
  }

  private getPDFReport() {
    if ( this.debug ) { console.log( 'photogram :: getPDFReport()'); }
    this.fourD.V.searchByObject(JobBatch).equals('parent', this.currentJob).sortBy('dateUpdated', true).limit(1).queryObservable().subscribe(res => {
      if ( this.debug ) { console.log( '%c photogram :: getPDFReport() items', Constants._red, res ); }
      if (res && res.items.length > 0) {
        res.items[0].outputs.queryObservable().subscribe(files => {
          if (files && files.items.length > 0) {
            files.items = files.items.filter(f => f.name.indexOf('pdf') !== -1);
            if (files.items[0])
              this.pdfRefport = files.items[0]
          }
          if ( this.debug ) { console.log( 'photogram :: getPDFReport() latest jobBatch, with files created', files ); }

          // check transforms for the files, and update the state of the job
          this.getTransformsForCurrentJob().subscribe( items => {
            if ( this.debug ) { console.log( 'photogram :: getPDFReport() getTransformsForCurrentJob()', items ); }
            // yes, there's a few Transforms on it
            if (items && items.length > 0) {

              items.forEach(value => {
 
                // check if any of these transforms are preview or full-job files, and set state accordingly
                this.checkTransformsForState( value );

              });
            }
          });
          
        })
      } else {
        if ( this.debug ) { console.log( 'photogram :: getPDFReport() NONE found'); }
      }
    })
  }

  private checkInputDatasetsExist() {
    if ( this.debug ) { console.log('photogram.comp :: checkInputDatasetsExist()' ); }
    this.addSubscription('test',
      this.currentJob.inputDatasets.queryObservable().subscribe(value => {
        if ( this.debug ) { console.log('photogram.comp :: checkInputDatasetsExist() values', value.items ); }
          if (value.items && value.items.length > 0) {
            this.folderAdded = true;
            
            value.items.forEach(value1 => {

              if ( this.debug ) { console.log('photogram.comp :: checkInputDatasetsExist() dataset "'+value1.name+'" vs. "'+this.mapService.FOURDDMAPPER_REFERENCE+'"' ); }
        
              if (value1.name.indexOf(this.mapService.FOURDDMAPPER_REFERENCE) !== -1) {
                this.referenceUploaded = true;
              }
              if (value1.name.indexOf(this.mapService.FOURDDMAPPER_REFERENCE) === -1) {
                this.metaDataUploaded = true;
              }
            });
          }
        },
        error1 => {
          console.log('Error', error1.error.message)
        }))
  }







   // for debugging
   fetchCheck ( p:string, e:any ) {
    if ( e[p] ) {
      return e[p];
    }
    return 'n/a';
  }
  // for debugging
  fetchFromItems ( items:any ) {
    let ret = [];
    items.forEach(e => {
      ret.push(
        { id: e.id, name: e.name, uid: e.uid,
          type: this.fetchCheck ( 'type', e),
          _objType: this.fetchCheck ( '_objType', e),
          desc: this.fetchCheck ( 'desc', e),
          status: this.fetchCheck ( 'status', e),
          fails: this.fetchCheck ( 'fails', e),
          needsCRS: this.fetchCheck ( 'needsCRS', e),
          needsInput: this.fetchCheck ( 'needsInput', e),
          implementation: this.fetchCheck ( 'implementation', e),
          incomplete: this.fetchCheck ( 'incomplete', e),
         }
      )
    });
    return ret;
  }


}
